/**
 * @generated SignedSource<<cdf8ac85d39979ffe5815039cca6fe5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizThemeLayout_theme",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "participativeModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsDatavizTabs_participativeModule"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizThemeViewSidebar_theme"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizViewModeSwitch_theme"
    }
  ],
  "type": "Theme",
  "abstractKey": null
};

node.hash = "237a0e88544b271bdc6f0cd2c4f887cf";

module.exports = node;
